import { render } from "./Canais.vue?vue&type=template&id=38158e3c&scoped=true"
import script from "./Canais.vue?vue&type=script&lang=js"
export * from "./Canais.vue?vue&type=script&lang=js"

import "./Canais.vue?vue&type=style&index=0&id=38158e3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38158e3c"]])

export default __exports__